import {Link} from "react-router-dom";
import {Button, styled} from "@mui/material";
import {ROUTES} from "../../app/Routes";

const StyledLinkButton = styled(Button)`
  border-color: #F57B20;

  &:hover {
    border-color: #F57B20;
  }
;
  font-size: 16px;
  line-height: 15px;
  color: #000000;
  text-transform: none;
  height: 35px;
  @media (max-width: 1320px) {
    font-size: 14px;
    line-height: 14px;
  }
`;

export const DocumentListLink = () => {
  return <Link to={ROUTES.Home}>
      <StyledLinkButton
          variant={'outlined'}
      >
          Список документов
      </StyledLinkButton>
  </Link>
}
